import { memo } from 'react';

import N8NIcon from '@/assets/n8n-logo.svg?react';
import { Logo, LogoProps } from '@/components/core';

export type N8NLogoProps = LogoProps;

const IN8NLogo = ({ className, ...rest }: N8NLogoProps) => {
  return (
    <Logo className={className} {...rest}>
      <N8NIcon />
    </Logo>
  );
};

export const N8NLogo = memo(IN8NLogo) as typeof IN8NLogo;
